var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPacman(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 39,
    viewBox: "0 0 49 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5473 19.5L34.541 29.3516C34.9348 29.6562 35.1316 30.2656 34.7379 30.7734C30.2098 37.2734 22.1379 40.4219 14.3613 38.0859C7.66758 36.1562 2.45039 30.2656 1.1707 23.1562C-0.994924 10.9687 8.15976 0.203125 19.5785 0.203125C25.7801 0.203125 31.5879 3.35156 35.0332 8.63281C35.3285 9.03906 35.2301 9.75 34.7379 10.0547L21.5473 19.5Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3281 22.5469C36.9591 22.5469 38.2812 21.1827 38.2812 19.5C38.2812 17.8173 36.9591 16.4531 35.3281 16.4531C33.6972 16.4531 32.375 17.8173 32.375 19.5C32.375 21.1827 33.6972 22.5469 35.3281 22.5469Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1719 22.5469C46.8028 22.5469 48.125 21.1827 48.125 19.5C48.125 17.8173 46.8028 16.4531 45.1719 16.4531C43.5409 16.4531 42.2188 17.8173 42.2188 19.5C42.2188 21.1827 43.5409 22.5469 45.1719 22.5469Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPacman);
export default __webpack_public_path__ + "static/media/pacman.8307d6abadfe0e020ad842ca6a1db589.svg";
export { ForwardRef as ReactComponent };